module.exports = __webpack_public_path__ + "img/fruit1.bef54dba.jpg";